import { Pipe, PipeTransform } from '@angular/core';
import { Course } from 'lms-api';

@Pipe({
  name: 'excludeArchivedCourses'
})
export class ExcludeArchivedCoursesPipe implements PipeTransform {

  transform(courses: Course[], ...includeStatuses: any[]): any {
    if(courses == null) return [];
    const filterable = [...courses];

    return filterable.filter(course => course.archived_course !== true);
  }

}
